<div class="container width1" >
  <ng-container *ngIf="!isReady"><br />
    <div class="progress">
      <div class="progress-bar" role="progressbar" [style.width.%]="progress*100" [attr.aria-valuenow]="progress" aria-valuemin="0" aria-valuemax="100"></div>
      <div class="background3"><h6>&nbsp;{{progress*100}}%</h6></div>
    </div>
    <hr />
  </ng-container>
  <div class="col">
    <div id="gameContainer_libre"></div>
    <button (click)="openFullscreen()">Cambiar a pantalla completa</button>
  </div>
</div>

